import { bytesToBase64 } from "utils/bytesToBase64";

const HMAC_KEY = "noKey";

export const hashString = async (str: string): Promise<string> => {
  const encoder = new TextEncoder();
  const hashDigest = await crypto.subtle.digest("SHA-256", encoder.encode(str));
  const hmacKey = await crypto.subtle.importKey(
    "raw",
    encoder.encode(HMAC_KEY),
    { name: "HMAC", hash: "SHA-512" },
    false,
    ["sign"]
  );
  const hmacResult = await crypto.subtle.sign("HMAC", hmacKey, hashDigest);

  return bytesToBase64(new Uint8Array(hmacResult));
};
